import { render, staticRenderFns } from "./PdfViewerUi.vue?vue&type=template&id=08ba0b88&scoped=true"
import script from "./PdfViewerUi.vue?vue&type=script&lang=js"
export * from "./PdfViewerUi.vue?vue&type=script&lang=js"
import style0 from "./PdfViewerUi.vue?vue&type=style&index=0&id=08ba0b88&prod&scoped=true&lang=scss"
import style1 from "./PdfViewerUi.vue?vue&type=style&index=1&id=08ba0b88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ba0b88",
  null
  
)

export default component.exports